import React, { useEffect, useState} from "react";
import axios from 'axios';
import url from 'url-parse';
import qs from 'qs';
import querystring from 'querystring';
import { jwtDecode } from "jwt-decode";

const maxAge = 120;

export default function LineLogin({
  clientID,
  clientSecret,
  nonce,
  scope,
  onSuccess,
  redirectURI
}){
    const [popup, setPopup] = useState();
  const getUniqState = () =>{
    var stat_str = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) { var r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8); return v.toString(16); });
    return stat_str;
    }
  const state = getUniqState()

  const lineLogin = () => {
    // Build query string.
    const query = querystring.stringify({
      response_type: 'code',
      client_id: clientID,
      state: state,
      scope: scope,
      nonce: nonce,
      prompt: 'consent',
      max_age: maxAge,
      bot_prompt: 'normal'
    });
    // Build the Line authorise URL.
    const lineAuthoriseURL =
      'https://access.line.me/oauth2/v2.1/authorize?' +
      query +
      '&redirect_uri=' +
      redirectURI;
    // Redirect to external URL.
    openPopup(lineAuthoriseURL);
  };

  const openPopup = link => {
    // 팝업 window의 크기 지정
    const width = 500; 
    const height = 800; 
   
    // 팝업을 부모 브라우저의 정 중앙에 나열
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;
    const windowFeatures = `width=${width},height=${height},left=${left},top=${top}`;
   
    // 팝업을 열고 window 속성 지정
    const popup = window.open(link, 'payment', windowFeatures);
    setPopup(popup)
  };

  useEffect(() => {
    const currentUrl = window.location.href;
    const searchParams = new URL(currentUrl).searchParams;
    const code = searchParams.get("code");
    if (code) {
      window.opener.postMessage({ code }, window.location.origin);
    }
  }, []);

  // 로그인 팝입이 열리면 로그인 로직을 처리합니다.
  useEffect(() => {
    if (!popup) {
      return;
    }

    const oAuthCodeListener = async (e) => {
      // 동일한 Origin 의 이벤트만 처리하도록 제한
      if (e.origin !== window.location.origin) {
        return;
      }
      const { code } = e.data;
      if (code) {
        await getAccessToken(code)
        console.log(`The popup URL has URL code param = ${code}`);
      }
      popup?.close();
      setPopup(null);
    };

    window.addEventListener("message", oAuthCodeListener, false);

    return () => {
      window.removeEventListener("message", oAuthCodeListener);
      popup?.close();
      setPopup(null);
    };
  }, [popup]);


  function parseJwt(token) {
    let base64Url = token.split('.')[1]
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    let jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join('')
    )
    return JSON.parse(jsonPayload)
  }


  const getAccessToken = (code) => {
 
      const reqBody = {
        grant_type: 'authorization_code',
        code: code,
        redirect_uri: redirectURI,
        client_id: clientID,
        client_secret: clientSecret
      };
      const reqConfig = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };

      axios
        .post(
          'https://api.line.me/oauth2/v2.1/token',
          qs.stringify(reqBody),
          reqConfig
        )
        .then((res) => {
            console.log("getAccess",res)
            if (onSuccess) {
                onSuccess(res.data);
            }

        })
        .catch((err) => {
          console.log(err);
        });
    }



  return (
    
      <button onClick={() => lineLogin()} className="snsBtn snsLinkLn" type="button" >라인로그인</button>
    
  );
};